import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {}
}

import { Form, Tag, TreeSelect, TreeSelectProps } from 'ant-design-vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvanceFilter',
  props: {
    filterBy: {},
    filters: {},
    favoriteID: {},
    filterIDs: {}
  },
  emits: ["filter"],
  setup(__props: any, { emit }) {

const props = __props;





const filterBy = ref<string[]>([...props.filterBy]);

let _firstTime = true;
function clearInvalidFilter() {
	if (_firstTime && filterBy.value && props.filters) {
		let allFilters: string[] = [];
		props.filters.forEach((filter) => {
			if (filter.children) {
				allFilters.push(...filter.children.map((f) => f.value as string));
			} else {
				allFilters.push(filter.value);
			}
		});
		filterBy.value = filterBy.value.filter((filter) => allFilters.includes(filter));
	}
	_firstTime = false;
}

function toggleSelectAllFiltering() {
	if (props.filters) {
		for (const value of props.filters.filter((f) => f.children)) {
			// is parent
			if (filterBy.value.includes(value.value) && value.children) {
				// have at least 1 of children on following parent
				if (
					value.children.filter((filter) => filterBy.value.includes(filter.value)).length ===
					value.children.length
				) {
					filterBy.value = filterBy.value.filter(
						(filter) =>
							filter !== value.value && !value.children?.map((v) => v.value).includes(filter)
					);
				} else {
					filterBy.value = Array.from(
						new Set(
							filterBy.value
								.filter((filter) => filter !== value.value)
								.concat(value.children.map((v) => v.value as string))
						).values()
					);
				}
			}
		}
		emit('filter', filterBy.value);
	}
}

watch(
	() => props.filterBy,
	(value) => {
		if (value.toString() !== filterBy.value.toString()) {
			filterBy.value = value;
		}
	}
);
watch(() => props.filters, clearInvalidFilter);
watch(filterBy, toggleSelectAllFiltering);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), { layout: "horizontal" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Form).Item, {
        label: "Filter",
        name: "hitomiFilters"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TreeSelect), {
            value: filterBy.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filterBy).value = $event)),
            "show-search": "",
            style: {"width":"100%"},
            "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
            placeholder: "Please select filter",
            "allow-clear": "",
            multiple: "",
            "show-checked-strategy": _unref(TreeSelect).SHOW_ALL,
            "tree-default-expand-all": "",
            "tree-data": _ctx.filters,
            "tree-node-filter-prop": "label"
          }, {
            tagRender: _withCtx(({ label, closable, onClose, option }) => [
              _createVNode(_unref(Tag), {
                closable: closable,
                color: option.color,
                style: {"margin-right":"3px"},
                onClose: onClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(label) + "   ", 1)
                ]),
                _: 2
              }, 1032, ["closable", "color", "onClose"])
            ]),
            title: _withCtx(({ value: val, label }) => [
              (val === 'parent 1-1')
                ? (_openBlock(), _createElementBlock("b", _hoisted_1, _toDisplayString(val), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(label), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["value", "show-checked-strategy", "tree-data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})